// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+nPRX","image":"Layout_image__wPzYH","color":"Layout_color__cKwVO","navbar":"Layout_navbar__CKhCz"};